import { fetchRenderManifestWithMeta } from '../services/kryspaceRenderService';
import type { KryspaceRenderManifest } from '../types/kryspaceRenderManifest';

export interface CompanyArtifactModelRoot {
  slug: string;
  title: string;
  statusPhrase?: string;
  source: 'linked-workspace' | 'self';
}

export function extractModelRootsFromManifest(
  manifest: KryspaceRenderManifest,
  workspaceSlug: string
): CompanyArtifactModelRoot[] {
  const linkedSection = manifest.sections.find((section) => section.id === 'linked-workspaces');
  const fromLinked = (linkedSection?.queue ?? [])
    .filter((item) => typeof item.workspaceSlug === 'string' && item.workspaceSlug.trim().length > 0)
    .map((item) => ({
      slug: item.workspaceSlug!.trim(),
      title: item.title?.trim() || item.workspaceSlug!.trim(),
      statusPhrase: item.statusPhrase,
      source: 'linked-workspace' as const,
    }));

  if (fromLinked.length > 0) {
    return fromLinked;
  }

  return [
    {
      slug: workspaceSlug,
      title: manifest.title?.trim() || workspaceSlug,
      source: 'self',
    },
  ];
}

/** Root models from company_model IntentML (linked workspaces in attention manifest). */
export async function fetchCompanyArtifactModelRoots(
  workspaceSlug: string
): Promise<CompanyArtifactModelRoot[]> {
  const slug = workspaceSlug.trim();
  if (!slug) return [];

  try {
    const { manifest } = await fetchRenderManifestWithMeta(slug);
    return extractModelRootsFromManifest(manifest, slug);
  } catch {
    return [{ slug, title: slug, source: 'self' }];
  }
}
